module.exports = __webpack_public_path__ + "img/21_83.a78e129b.png";